'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _PackageItem = require('../PackageItem.scss');var styles = _interopRequireWildcard(_PackageItem);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var PublisherPackageDetails = function PublisherPackageDetails(props) {return (
    _react2.default.createElement('div', { className: styles.publisherPackage },
      _react2.default.createElement('div', { className: styles.description },
        _react2.default.createElement('div', { className: styles.publisherPackageTitle }, props.translate(props.packageType + 'AdTitle')),
        _react2.default.createElement('div', null, props.translate(props.packageType + 'AdDescription'))),

      _react2.default.createElement('div', { className: styles.publisherPromotionPeriod },
        props.translate('promotionPeriod').replace('%s', props.selectedPeriod)),

      props.requiredMessage &&
      _react2.default.createElement('div', { className: styles.requiredMessage }, props.requiredMessage)));};




PublisherPackageDetails.propTypes = {
  translate: _propTypes2.default.func,
  packageType: _propTypes2.default.string,
  selectedPeriod: _propTypes2.default.number,
  requiredMessage: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.bool]) };exports.default =


PublisherPackageDetails;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PackageItem/Details/PublisherPackageDetails.js
// module id = 2783
// module chunks = 0